(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[character];
    });
  }

  function init(root) {
    if (!root || root.dataset.eipcCartReady === 'true') return;
    root.dataset.eipcCartReady = 'true';
    document.body.classList.add('eipc-cart-active');

    var META = window.EIPC_META || {};
    var locale = root.dataset.locale || 'nl-NL';
    var currency = root.dataset.currency || 'EUR';
    var freeShipping = Number(root.dataset.freeShippingCents || 10000);
    var shippingCost = Number(root.dataset.shippingCostCents || 395);
    var toastElement = root.querySelector('[data-page-toast]');
    var toastTimer;
    var currentCart = null;
    var busy = false;

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, {style:'currency', currency:currency}).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '€' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
      }
    }

    function amount(cents) {
      return Number(((Number(cents) || 0) / 100).toFixed(2));
    }

    function eventId(name) {
      var suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      return 'eipc-' + String(name || 'event').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + suffix;
    }

    function trackingItem(item) {
      item = item || {};
      var metadata = metadataFor(item);
      var unitCents = Number(item.final_price || item.price || item.original_price || 0);
      return {
        item_id:String(item.variant_id || item.id || item.product_id || handleOf(item)),
        item_name:metadata.name || item.product_title || item.title || handleOf(item) || 'Piercing',
        item_brand:item.vendor || 'Empire Ink',
        item_category:'Piercing',
        item_variant:item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : undefined,
        price:amount(unitCents),
        quantity:Number(item.quantity || 1)
      };
    }

    function productEventData(item, ga4Name, metaName, extra) {
      item = item || {item_id:'', item_name:'Piercing', item_brand:'Empire Ink', item_category:'Piercing', price:0, quantity:1};
      var quantity = Number(item.quantity || 1);
      var value = Number((Number(item.price || 0) * quantity).toFixed(2));
      return Object.assign({
        ga4_event:ga4Name,
        meta_event:metaName || undefined,
        currency:currency,
        value:value,
        content_type:'product',
        content_ids:[String(item.item_id || '')],
        content_name:item.item_name,
        contents:[{id:String(item.item_id || ''), quantity:quantity, item_price:Number(item.price || 0)}],
        items:[item],
        ecommerce:{currency:currency, value:value, items:[item]}
      }, extra || {});
    }

    function cartEventData(cart, ga4Name, metaName, extra) {
      cart = cart || {};
      var eventItems = (cart.items || []).map(trackingItem);
      var value = amount(cart.total_price || 0);
      return Object.assign({
        ga4_event:ga4Name,
        meta_event:metaName || undefined,
        currency:currency,
        value:value,
        item_count:Number(cart.item_count || 0),
        content_type:'product',
        content_ids:eventItems.map(function (item) { return String(item.item_id); }),
        contents:eventItems.map(function (item) { return {id:String(item.item_id), quantity:Number(item.quantity || 1), item_price:Number(item.price || 0)}; }),
        items:eventItems,
        ecommerce:{currency:currency, value:value, items:eventItems}
      }, extra || {});
    }

    function track(name, data) {
      var details = Object.assign({}, data || {});
      var id = details.event_id || eventId(name);
      details.event_id = id;
      details.eventID = id;
      var payload = Object.assign({
        event:name,
        microsite:'empire-piercings-cart',
        page_path:location.pathname
      }, details);
      window.dataLayer = window.dataLayer || [];
      if (payload.ecommerce) window.dataLayer.push({ecommerce:null});
      window.dataLayer.push(payload);
      return id;
    }

    function toast(message) {
      if (!toastElement) return;
      toastElement.textContent = message;
      toastElement.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastElement.classList.remove('is-visible'); }, 2400);
    }

    function handleOf(item) {
      if (item && item.handle) return item.handle;
      var match = String(item && item.url || '').match(/\/products\/([^?]+)/);
      return match ? match[1] : '';
    }

    function metadataFor(item) {
      return META[handleOf(item)] || {};
    }

    function selectedDelivery() {
      var selected = root.querySelector('[name="eipc_delivery"]:checked');
      return selected ? selected.value : 'post';
    }

    function shippingFor(cart) {
      if (!cart || !cart.item_count || selectedDelivery() === 'studio') return 0;
      return Number(cart.total_price || 0) >= freeShipping ? 0 : shippingCost;
    }

    function dispatchInfo() {
      var now = new Date();
      var parts = String(root.dataset.shippingCutoff || '16:30').split(':');
      var cutoff = new Date(now);
      cutoff.setHours(Number(parts[0] || 16), Number(parts[1] || 30), 0, 0);
      var shipsToday = now < cutoff && now.getDay() !== 0;
      var delivery = new Date(now);
      delivery.setDate(delivery.getDate() + (shipsToday ? 1 : 2));
      while (delivery.getDay() === 0) delivery.setDate(delivery.getDate() + 1);
      return {
        today: shipsToday,
        dispatch: shipsToday ? 'vandaag verzonden' : 'volgende werkdag verzonden',
        delivery: new Intl.DateTimeFormat(locale, {weekday:'long', day:'numeric', month:'long'}).format(delivery)
      };
    }

    function decorateNames() {
      root.querySelectorAll('[data-cart-product-name][data-handle]').forEach(function (element) {
        var metadata = META[element.dataset.handle] || {};
        if (metadata.name) element.textContent = metadata.name;
      });
      root.querySelectorAll('[data-page-line]').forEach(function (line) {
        var metadata = META[line.dataset.handle] || {};
        var name = line.querySelector('[data-cart-product-name]');
        var description = line.querySelector('.eipc-page-line-meta');
        var tip = line.querySelector('[data-page-size-tip]');
        if (name && metadata.name) name.textContent = metadata.name;
        if (description && metadata.sub) description.textContent = metadata.sub;
        if (tip) tip.hidden = !(metadata.fresh && metadata.type === 'labret' && (metadata.len || []).indexOf('8') !== -1);
      });
    }

    function renderCart(cart) {
      currentCart = cart;
      var dispatch = dispatchInfo();
      var itemCount = Number(cart.item_count || 0);
      var originalTotal = Number(cart.original_total_price || cart.total_price || 0);
      var total = Number(cart.total_price || 0);
      var discount = Number(cart.total_discount || Math.max(0, originalTotal - total));
      var shipping = shippingFor(cart);
      var estimatedTotal = total + shipping;
      var remaining = Math.max(0, freeShipping - total);
      var jewelryCount = (cart.items || []).reduce(function (count, item) {
        return count + (metadataFor(item).type === 'onderdeel' ? 0 : Number(item.quantity || 0));
      }, 0);

      root.querySelectorAll('[data-page-cart-count]').forEach(function (element) { element.textContent = '(' + itemCount + ')'; });
      root.querySelectorAll('[data-page-summary-count]').forEach(function (element) { element.textContent = itemCount; });
      root.querySelectorAll('[data-page-subtotal]').forEach(function (element) { element.textContent = money(originalTotal); });
      root.querySelectorAll('[data-page-discount]').forEach(function (element) { element.textContent = '−' + money(discount); });
      root.querySelectorAll('[data-page-discount-row]').forEach(function (element) { element.hidden = discount <= 0; });
      root.querySelectorAll('[data-page-shipping-cost], [data-page-post-price]').forEach(function (element) {
        element.innerHTML = shipping === 0 ? '<span>Gratis</span>' : money(shipping);
      });
      root.querySelectorAll('[data-page-total], [data-page-mobile-total]').forEach(function (element) { element.textContent = money(estimatedTotal); });

      var shippingBox = root.querySelector('[data-page-shipping]');
      var shippingText = root.querySelector('[data-page-shipping-text]');
      var shippingBar = root.querySelector('[data-page-shipping-bar]');
      if (shippingBox) shippingBox.classList.toggle('is-free', remaining === 0);
      if (shippingText) {
        shippingText.innerHTML = remaining > 0
          ? 'Nog <b>' + money(remaining) + '</b> tot gratis verzending'
          : '<b>Gratis verzending behaald.</b> ' + (dispatch.today ? 'Voor de cutoff: vandaag op de post.' : 'De volgende werkdag op de post.');
      }
      if (shippingBar) shippingBar.style.width = Math.min(100, freeShipping ? (total / freeShipping) * 100 : 100) + '%';

      var setText = root.querySelector('[data-page-set-text]');
      if (setText) {
        if (jewelryCount >= 3) setText.innerHTML = '<b>10% setkorting actief</b>' + (discount ? ' · je bespaart ' + money(discount) : ' · wordt automatisch berekend');
        else if (jewelryCount === 2) setText.innerHTML = '<b>Nog 1 sieraad</b> voor 10% setkorting';
        else if (jewelryCount === 1) setText.innerHTML = '<b>Nog 1 sieraad</b> voor 5% setkorting · 3 sieraden = 10%';
        else setText.textContent = '2 sieraden = 5% · 3 of meer = 10% korting';
      }
      root.querySelectorAll('[data-page-set-dot]').forEach(function (dot) {
        dot.classList.toggle('is-active', jewelryCount >= Number(dot.dataset.pageSetDot || 0));
      });

      root.querySelectorAll('[data-page-dispatch]').forEach(function (element) { element.textContent = dispatch.dispatch; });
      var delivery = root.querySelector('[data-page-delivery]');
      if (delivery) {
        delivery.innerHTML = selectedDelivery() === 'studio'
          ? '<b>Gratis afhalen in Rotterdam</b><span>Klaar zodra je bevestiging binnen is.</span>'
          : '<b>Verwachte bezorging: ' + escapeHtml(dispatch.delivery) + '</b><span>PostNL brievenbuspakket met track &amp; trace.</span>';
      }
      var mobileCopy = root.querySelector('[data-mobile-summary-copy]');
      if (mobileCopy) mobileCopy.textContent = shipping === 0 ? 'Gratis verzending / afhalen' : '+ ' + money(shipping) + ' verzending';
      var klarna = root.querySelector('[data-page-klarna]');
      if (klarna) klarna.textContent = estimatedTotal >= 3500 ? 'Betaal later met Klarna is beschikbaar vanaf €35.' : 'Klarna beschikbaar vanaf €35.';
      root.querySelectorAll('[data-page-pickup] label').forEach(function (label) {
        var radio = label.querySelector('input');
        label.classList.toggle('is-selected', Boolean(radio && radio.checked));
      });
    }

    async function getCart() {
      var response = await fetch(root.dataset.cartUrl, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart');
      return response.json();
    }

    async function changeLine(key, quantity) {
      if (busy) return;
      busy = true;
      try {
        var response = await fetch(root.dataset.cartChangeUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key, quantity:Math.max(0, Number(quantity || 0))})
        });
        if (!response.ok) throw new Error('change');
        track('eipc_cart_update', {line_key:key, quantity:Number(quantity || 0)});
        window.location.reload();
      } catch (error) {
        busy = false;
        toast('Winkelwagen kon niet worden bijgewerkt. Probeer opnieuw.');
      }
    }

    async function addVariant(variantId, button, reloadAfter) {
      if (busy || !variantId) return false;
      busy = true;
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Toevoegen…';
      }
      try {
        var response = await fetch(root.dataset.cartAddUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(variantId), quantity:1}]})
        });
        if (!response.ok) throw new Error('add');
        var added = await response.json();
        var addedLine = added && Array.isArray(added.items) ? added.items[0] : added;
        try { if (window.EmpireCommerceEmit) window.EmpireCommerceEmit('add', {line:addedLine, currency:currency}); } catch (trackingError) {}
        var item = addedLine && (addedLine.id || addedLine.variant_id)
          ? trackingItem(addedLine)
          : {item_id:String(variantId), item_name:'Piercing', item_brand:'Empire Ink', item_category:'Piercing', price:0, quantity:1};
        track('eipc_add_to_cart', productEventData(item, 'add_to_cart', 'AddToCart', {
          variant_id:String(variantId),
          source:'cart_recommendation'
        }));
        if (reloadAfter !== false) window.location.reload();
        return true;
      } catch (error) {
        busy = false;
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
        toast('Toevoegen mislukt. Controleer de gekozen maat.');
        return false;
      }
    }

    function savedHandles() {
      try {
        var stored = JSON.parse(localStorage.getItem('eipc_wishlist_handles') || '[]');
        return Array.isArray(stored) ? stored : [];
      } catch (error) {
        return [];
      }
    }

    function saveHandle(handle) {
      if (!handle) return;
      var handles = savedHandles().filter(function (value) { return value !== handle; });
      handles.unshift(handle);
      try { localStorage.setItem('eipc_wishlist_handles', JSON.stringify(handles.slice(0, 12))); } catch (error) {}
    }

    async function saveForLater(line) {
      saveHandle(line.dataset.handle);
      toast('Bewaard voor later');
      track('eipc_save_for_later', {handle:line.dataset.handle});
      await changeLine(line.dataset.lineKey, 0);
    }

    async function changeVariant(line) {
      if (busy) return;
      var variantsNode = line.querySelector('[data-line-variants]');
      if (!variantsNode) return;
      var variants;
      try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }
      var values = Array.prototype.slice.call(line.querySelectorAll('[data-variant-option]')).sort(function (a, b) {
        return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
      }).map(function (select) { return select.value; });
      var match = variants.find(function (variant) {
        return variant.available !== false && (variant.options || []).every(function (option, index) { return option === values[index]; });
      });
      if (!match) {
        toast('Deze combinatie is momenteel niet op voorraad.');
        return;
      }
      if (String(match.id) === String(line.dataset.variantId)) return;
      busy = true;
      try {
        var addResponse = await fetch(root.dataset.cartAddUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(match.id), quantity:Number(line.dataset.quantity || 1)}]})
        });
        if (!addResponse.ok) throw new Error('variant-add');
        var removeResponse = await fetch(root.dataset.cartChangeUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:line.dataset.lineKey, quantity:0})
        });
        if (!removeResponse.ok) throw new Error('variant-remove');
        track('eipc_cart_variant_change', {from_variant:String(line.dataset.variantId), to_variant:String(match.id)});
        window.location.reload();
      } catch (error) {
        busy = false;
        toast('De maat kon niet worden gewijzigd. Controleer je winkelwagen.');
      }
    }

    async function updateDelivery(value) {
      if (busy || !currentCart) return;
      root.querySelectorAll('[data-page-pickup] label').forEach(function (label) {
        var radio = label.querySelector('input');
        label.classList.toggle('is-selected', Boolean(radio && radio.checked));
      });
      renderCart(currentCart);
      try {
        var response = await fetch(root.dataset.cartUpdateUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({attributes:{eipc_delivery:value}})
        });
        if (!response.ok) throw new Error('delivery');
        track('eipc_delivery_choice', {delivery:value});
      } catch (error) {
        toast('De bezorgkeuze kon niet worden opgeslagen.');
      }
    }

    function compatible(product, firstMetadata) {
      var metadata = META[product.handle] || {};
      if (!firstMetadata || !Object.keys(firstMetadata).length || !Object.keys(metadata).length) return true;
      var sameGauge = metadata.gauge && firstMetadata.gauge && metadata.gauge === firstMetadata.gauge;
      var sharedZone = (metadata.zone || []).some(function (zone) { return (firstMetadata.zone || []).indexOf(zone) !== -1; });
      return sameGauge || sharedZone || metadata.type === 'onderdeel';
    }

    function recommendationCard(product) {
      var metadata = META[product.handle] || {};
      var variant = (product.variants || []).find(function (item) { return item.available !== false; }) || (product.variants || [])[0];
      var image = product.featured_image || (product.images || [])[0] || '';
      if (image && typeof image === 'object') image = image.url || image.src || '';
      return '<article>' +
        '<a href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(metadata.name || product.title) + '" loading="lazy">' : '<span class="eipc-recommendation-placeholder"></span>') +
          '<b>' + escapeHtml(metadata.name || product.title) + '</b>' +
          (metadata.sub ? '<small>' + escapeHtml(metadata.sub) + '</small>' : '') +
        '</a>' +
        '<span>' + money(product.price || (variant && variant.price) || 0) + '</span>' +
        (variant ? '<button type="button" data-page-add data-variant-id="' + escapeHtml(variant.id) + '">Toevoegen</button>' : '') +
      '</article>';
    }

    async function loadRecommendations(cart) {
      var container = root.querySelector('[data-page-recommendations]');
      if (!container || !cart.items || !cart.items.length || !root.dataset.recommendationsUrl) return;
      try {
        var first = cart.items[0];
        var endpoint = root.dataset.recommendationsUrl.replace(/\.json$/, '') + '.json?product_id=' + encodeURIComponent(first.product_id) + '&limit=8&intent=related';
        var response = await fetch(endpoint, {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('recommendations');
        var payload = await response.json();
        var products = Array.isArray(payload.products) ? payload.products : [];
        var matched = products.filter(function (product) { return compatible(product, metadataFor(first)); });
        if (matched.length < 4) {
          products.forEach(function (product) {
            if (matched.indexOf(product) === -1) matched.push(product);
          });
        }
        matched = matched.slice(0, 4);
        container.innerHTML = matched.length ? matched.map(recommendationCard).join('') : '<p>Bekijk meer passende sieraden in de collectie.</p>';
      } catch (error) {
        container.innerHTML = '<p><a href="' + escapeHtml(root.dataset.collectionUrl) + '">Bekijk meer passende sieraden in de collectie →</a></p>';
      }
    }

    async function loadWishlist() {
      var container = root.querySelector('[data-page-wishlist]');
      if (!container) return;
      var handles = savedHandles().slice(0, 4);
      if (!handles.length) return;
      try {
        var products = await Promise.all(handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}}).then(function (response) {
            if (!response.ok) throw new Error('wishlist');
            return response.json();
          });
        }));
        container.innerHTML = '<div class="eipc-empty-product-grid">' + products.map(recommendationCard).join('') + '</div>';
      } catch (error) {
        container.textContent = 'Je bewaarde sieraden konden niet worden geladen.';
      }
    }

    root.addEventListener('click', function (event) {
      var add = event.target.closest('[data-page-add]');
      if (add) {
        event.preventDefault();
        addVariant(add.dataset.variantId, add, true);
        return;
      }
      var line = event.target.closest('[data-page-line]');
      var quantity = event.target.closest('[data-page-quantity]');
      if (line && quantity) {
        changeLine(line.dataset.lineKey, quantity.dataset.pageQuantity);
        return;
      }
      if (line && event.target.closest('[data-page-remove]')) {
        changeLine(line.dataset.lineKey, 0);
        return;
      }
      if (line && event.target.closest('[data-page-save]')) {
        saveForLater(line);
        return;
      }
      if (event.target.closest('[data-page-apply-code]')) {
        var code = root.querySelector('[data-page-discount-code]');
        if (!code || !code.value.trim()) {
          toast('Vul eerst een kortingscode in.');
          return;
        }
        window.location.href = '/discount/' + encodeURIComponent(code.value.trim()) + '?redirect=/cart';
        return;
      }
      if (event.target.closest('[data-page-mobile-checkout]')) {
        var form = root.querySelector('.eipc-cart-checkout-form');
        if (form) form.requestSubmit();
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-variant-option]')) {
        changeVariant(event.target.closest('[data-page-line]'));
      }
      if (event.target.matches('[name="eipc_delivery"]')) {
        updateDelivery(event.target.value);
      }
    });

    var checkoutForm = root.querySelector('.eipc-cart-checkout-form');
    if (checkoutForm) checkoutForm.addEventListener('submit', function () {
      try { if (window.EmpireCommerceEmit) window.EmpireCommerceEmit('begin', {cart:currentCart}); } catch (trackingError) {}
      track('eipc_begin_checkout', currentCart
        ? cartEventData(currentCart, 'begin_checkout', 'InitiateCheckout', {
            delivery:selectedDelivery(),
            shipping_value:amount(shippingFor(currentCart)),
            source:'piercing_cart'
          })
        : {ga4_event:'begin_checkout', meta_event:'InitiateCheckout', currency:currency, value:0, delivery:selectedDelivery(), source:'piercing_cart'});
    });

    decorateNames();
    loadWishlist();
    getCart().then(function (cart) {
      renderCart(cart);
      loadRecommendations(cart);
      track('eipc_cart_view', cartEventData(cart, 'view_cart', '', {source:'piercing_cart'}));
    }).catch(function () {
      toast('Winkelwagen kon niet worden geladen. Vernieuw de pagina.');
    });
  }

  function boot() {
    document.querySelectorAll('[data-eipc-cart-page]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

